import { InputAdornment, TextField } from "@mui/material"
import { useState } from "react"
import { SxOneInputProps, SxOneTextField } from "./SxOneDatePicker"

const OneDatePicker = ({
    name = "",
    defaultValue,
    StartIcon = null,
    EndIcon = null,
    IconCallback = false,
    maxLength = "",
    transform = false,
    disabled = false,
    readOnly = false,
    onBlur = () => {},
    callback,
    type = "datetime-local",
    inputformat = "DD/MM/YYYY HH:mm:ss",
    newSx = {},
    ...rest
}) => {
    const [dateTime, setDateTime] = useState(defaultValue || "")

    const handleDateTimeChange = (event) => {
        setDateTime(event.target.value)
        rest.onDateTimeChange && rest.onDateTimeChange(event.target.value)
        let newEvent = {
            target: {
                name: event.target.name,
                value: event.target.value.replace("T", " "),
                type: 'outro'
            }
        }
        callback(newEvent)
    }

    return (
        <TextField
            variant="outlined"
            sx={{ ...SxOneTextField, backgroundColor: (disabled || readOnly ? "#c9c7c7" : "#fff"), ...newSx }}
            name={name}
            {...rest}
            value={dateTime}
            type={type}
            onBlur={onBlur}
            inputformat={inputformat}
            inputProps={{
                maxLength,
                disabled,
                readOnly,
                // required,
                sx: { padding: '0 5px', fontSize: '13px', ...newSx },
                ...rest
            }}
            InputProps={{
                sx: { ...SxOneInputProps, ...newSx },
                startAdornment: StartIcon
                    ? (
                        <InputAdornment position="start">
                            <StartIcon onClick={() => IconCallback()} />
                        </InputAdornment>
                    )
                    : null,
                endAdornment: EndIcon
                    ? (
                        <InputAdornment position="end">
                            <EndIcon style={{ cursor: 'pointer' }} onClick={() => IconCallback()}/>
                        </InputAdornment>
                    )
                    : null
            }}
            onChange={handleDateTimeChange}
        />
    )
}

export default OneDatePicker
